import {PriceModel} from './Price.model';
import {ItemModifier} from '@wix/auto_sdk_ecom_current-cart';
import {ModelContext} from '../../types/app.types';

export class ModifierModel {
  public quantity?: number;
  public label: string;
  public details?: string;
  public price?: PriceModel;

  constructor(params: ModifierModel) {
    this.quantity = params?.quantity;
    this.label = params?.label;
    this.details = params?.details;
    this.price = params?.price;
  }

  public static fromSDK(modifier: ItemModifier, modelContext: ModelContext): ModifierModel {
    return new ModifierModel({
      quantity: modifier.quantity ?? undefined,
      label: modifier.label?.translated ?? modifier.label?.original ?? /* istanbul ignore next */ '',
      details: modifier.details?.translated ?? modifier.details?.original ?? /* istanbul ignore next */ undefined,
      price: modifier.price ? PriceModel.fromSDK(modifier.price, modelContext) : undefined,
    });
  }
}
